var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaceGrinHearts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.281 14.32a1.961 1.961 0 012.397-1.383c1.043.281 1.658 1.354 1.383 2.344l-1.026 3.861a.932.932 0 01-1.148.662l-3.815-1.02a1.954 1.954 0 01-1.38-2.39c.279-1.043 1.351-1.664 2.341-1.383l.997.252.252-.943zm11.69.943l.943-.252a1.957 1.957 0 012.397 1.383 1.958 1.958 0 01-1.383 2.39l-3.815 1.02a.932.932 0 01-1.148-.662l-1.025-3.861c-.276-.99.34-2.063 1.383-2.344a1.961 1.961 0 012.396 1.383l.252.943z",
    fill: "#25B000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5 20.373c0-8.286 6.715-15 15-15s15 6.714 15 15c0 8.285-6.715 15-15 15s-15-6.715-15-15zm15.018 4.441c-2.778 0-5.403-.404-7.723-1.113-.72-.223-1.424.404-1.13 1.095 1.458 3.463 4.874 5.89 8.853 5.89 3.978 0 7.388-2.427 8.853-5.89.293-.691-.41-1.318-1.13-1.095-2.327.709-4.946 1.113-7.723 1.113zm-3.34-11.877a1.962 1.962 0 00-2.397 1.383l-.252.943-.996-.252c-.99-.281-2.062.34-2.341 1.383a1.954 1.954 0 001.38 2.39l3.815 1.02a.932.932 0 001.148-.662l1.026-3.861c.275-.99-.34-2.063-1.383-2.344zm9.04 1.383a1.962 1.962 0 00-2.396-1.383c-1.043.281-1.658 1.354-1.383 2.344l1.026 3.861a.932.932 0 001.148.662l3.815-1.02a1.958 1.958 0 001.383-2.39 1.957 1.957 0 00-2.397-1.383l-.943.252-.252-.943z",
    fill: "#25B000"
  })));
}

export default SvgFaceGrinHearts;